import { GalleryInfosAction, GalleryInfosActionKeys } from './actions';
import { Api } from '../../typings/api';
import { defaultTemplate } from '../../utils/styles-constants';
import Utils from '../../utils/index';

let initialState = {
	isConfigLoaded: false,
	isConfigFetching: false,
	isLocalTemplateLoaded: false,
	isLocalTemplateFetching: false,
	isRemoteTemplateLoaded: false,
	isRemoteTemplateFetching: false,
	forceViewUpdateCount: 0,
	forceSplashScreen: true,
	template: defaultTemplate,
	customCSS: '',
} as GalleryInfosState;

export interface GalleryInfosState {
	isConfigLoaded: boolean;
	isConfigFetching: boolean;
	isLocalTemplateLoaded: boolean;
	isLocalTemplateFetching: boolean;
	isRemoteTemplateLoaded: boolean;
	isRemoteTemplateFetching: boolean;
	config: Api.Config;
	template: Api.Template;
	customCSS: string;
	forceViewUpdateCount: number;
	forceSplashScreen: boolean;
}

export function galleryInfos(
	state: GalleryInfosState = initialState,
	action: GalleryInfosAction
): GalleryInfosState {
	let propertiesToUpdate;
	let newState = {
		...state,
	};
	let newTemplate;
	let newCommonStyles;
	let customCSS;
	switch (action.type) {
		case GalleryInfosActionKeys.REQUEST_CONFIG:
			return {
				...state,
				isConfigFetching: true,
			};
		case GalleryInfosActionKeys.RECEIVE_CONFIG:
			return {
				...state,
				isConfigFetching: false,
				isConfigLoaded: true,
				config: action.data,
			};
		case GalleryInfosActionKeys.REQUEST_LOCAL_TEMPLATE:
			return {
				...state,
				isLocalTemplateFetching: true,
			};
		case GalleryInfosActionKeys.RECEIVE_LOCAL_TEMPLATE:
			// Merge templates instead of replacing in case the remote template is incomplete
			newTemplate = Utils.deepCopy(action.data);
			newCommonStyles = state.template.commonStyles;
			updateObjectProperties(newCommonStyles, newTemplate.commonStyles);
			newTemplate.commonStyles = newCommonStyles;
			return {
				...state,
				isLocalTemplateFetching: false,
				isLocalTemplateLoaded: true,
				template: newTemplate
			};
		case GalleryInfosActionKeys.SET_CUSTOM_CSS:
			customCSS = action.data;
			return {
				...state,
				customCSS
			};
		case GalleryInfosActionKeys.REQUEST_REMOTE_TEMPLATE:
			return {
				...state,
				isRemoteTemplateFetching: true,
			};
		case GalleryInfosActionKeys.RECEIVE_REMOTE_TEMPLATE:
			// Merge templates instead of replacing in case the remote template is incomplete
			newTemplate = Utils.deepCopy(action.data);
			newCommonStyles = state.template.commonStyles;
			updateObjectProperties(newCommonStyles, newTemplate.commonStyles);
			newTemplate.commonStyles = newCommonStyles;
			return {
				...state,
				isRemoteTemplateFetching: false,
				isRemoteTemplateLoaded: true,
				template: newTemplate
			};
		case GalleryInfosActionKeys.FORCE_VIEW_UPDATE:
			return {
				...state,
				forceViewUpdateCount: state.forceViewUpdateCount + 1
			};
		case GalleryInfosActionKeys.SET_FORCE_SPLASH_SCREEN:
			return {
				...state,
				forceSplashScreen: action.isShown
			};
		case GalleryInfosActionKeys.UPDATE_TEMPLATE_BRAND:
			newState = Utils.deepCopy(state);
			propertiesToUpdate = action.value;

			if (newState.template.brand) {
				updateObjectProperties(newState.template.brand, propertiesToUpdate);
			}

			return newState;
		case GalleryInfosActionKeys.UPDATE_TEMPLATE_COMMONSTYLES:
			newState = Utils.deepCopy(state);
			propertiesToUpdate = action.value;

			if (newState.template.commonStyles) {
				updateObjectProperties(newState.template.commonStyles, propertiesToUpdate);
			}

			return newState;
		default:
			return state;
	}
}

function updateObjectProperties(object: {}, propertiesToUpdate: {}) {
	if (object) {
		for (let k in propertiesToUpdate) {
			if (propertiesToUpdate.hasOwnProperty(k)) {
				const updateValue = propertiesToUpdate[k];
				if (object[k] !== null && typeof object[k] === 'object') {
					object[k] = updateObjectProperties(object[k], updateValue);
				} else {
					object[k] = updateValue !== undefined ? updateValue : object[k];
				}
			}
		}
	}

	return object;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Gallery/reducer.ts